import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
export var useEditorToolbarChangeDetector = function useEditorToolbarChangeDetector(ButtonWrapper) {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    toolbarMutationCount = _useState2[0],
    setToolbarMutationCount = _useState2[1];
  useEffect(function () {
    if (!ButtonWrapper) {
      return;
    }
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var addedNodes = mutation.addedNodes,
          removedNodes = mutation.removedNodes;
        // @ts-ignore error TS2488: Type 'NodeList' must have a '[Symbol.iterator]()' method that returns an iterator.
        // This was required when enrolling this package into JFE local consumption
        var isRelevantMutation = [].concat(_toConsumableArray(addedNodes), _toConsumableArray(removedNodes)).some(function (node) {
          return node.nodeType === 1 && node.nodeName === 'DIV';
        });
        if (isRelevantMutation) {
          setToolbarMutationCount(toolbarMutationCount + 1);
        }
      });
    });
    var mainToolBar = document.querySelector("[data-testid=\"ak-editor-main-toolbar\"]");
    if (mainToolBar) {
      observer.observe(mainToolBar, {
        childList: true,
        subtree: true
      });
    }
    return function () {
      observer.disconnect();
    };
  }, [toolbarMutationCount, ButtonWrapper]);
  return toolbarMutationCount;
};